<template>
  <div v-if="isShown">
    <div class="pop8"
         style="position: fixed; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);transform: translate(-50%, -50%);; z-index: 999;"
    >
      <div class="zd"></div>
      <a href="javascript:void 0;" v-if="!isCloseHidden" @click="close" class="close pa db">关闭</a>
      <p class="pop8_tit">
        <slot></slot>
      </p>
    </div>
    <div style="background-color: rgb(17, 17, 17); border-top: 1px solid rgb(17, 17, 17); position: absolute; z-index: 998; width: 100%; left: 0px; top: 0px; opacity: 0.7; display: block;"
         :style="{height:maskHeight+'px'}"></div>
  </div>
</template>

<script>
export default {
  name: "PopDialog",
  props: ["isShown", "isCloseHidden"],
  data() {
    return {
      maskHeight: ""
    }
  },
  mounted() {
    this.maskHeight = document.documentElement.scrollHeight
  },
  methods: {
    close() {
      this.$emit("update:isShown", false)
    }
  }
}
</script>

<style scoped>
</style>
